import { Nav } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { validateShippingContact } from '../../utils/shippingContact';

// Sticky scroll-spy that replaces the wizard's CheckoutSteps breadcrumb.
// `active` (from the screen's IntersectionObserver) highlights the section in
// view; a check mark appears once a step's data is present in the cart slice.
//
// UI polish: each step now shows a numbered dot (✓ when done), joined by a
// dashed connector line on desktop. `variant="horizontal"` renders the same
// steps as a compact scrollable pill bar for phones (see onepage.css).
const STEPS = [
  { id: 'catalog', label: '選購商品' },
  { id: 'cart', label: '購物車' },
  { id: 'shipping', label: '運送資訊' },
  { id: 'payment', label: '付款方式' },
  { id: 'review', label: '確認訂單' },
];

const OnePageStepper = ({ active, onJump, variant = 'vertical' }) => {
  const cart = useSelector((state) => state.cart);
  const s = cart.shippingAddress;

  const done = {
    catalog: cart.cartItems.length > 0,
    cart: cart.cartItems.length > 0,
    shipping: Boolean(
      cart.shippingMethod?.id && s?.address && s?.city && s?.postalCode && s?.country
    ) &&
      // + mandatory carrier contact (email, mobile, 黑貓 time slot)
      Object.keys(
        validateShippingContact({
          email: s?.email,
          mobile: s?.mobile,
          shippingMethodId: cart.shippingMethod?.id,
          deliveryTime: cart.shippingMethod?.deliveryTime,
        })
      ).length === 0,
    payment: Boolean(cart.paymentMethod),
    review: false,
  };

  const horizontal = variant === 'horizontal';

  return (
    <Nav
      as="nav"
      aria-label="結帳步驟"
      className={`op-stepper ${horizontal ? 'op-horizontal' : 'flex-column'}`}
      style={horizontal ? undefined : { position: 'sticky', top: '90px' }}
    >
      {STEPS.map((step, i) => (
        <Nav.Link
          key={step.id}
          active={active === step.id}
          aria-current={active === step.id ? 'step' : undefined}
          className={done[step.id] ? 'is-done' : ''}
          onClick={() => onJump(step.id)}
        >
          <span className="op-dot" aria-hidden="true">
            {done[step.id] ? '✓' : i + 1}
          </span>
          <span>
            {step.label}
            {done[step.id] && <span className="visually-hidden">（已完成）</span>}
          </span>
        </Nav.Link>
      ))}
    </Nav>
  );
};

export default OnePageStepper;
